module.exports = __webpack_public_path__ + "img/product-placeholder-4.9caded5.png";